import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export const useCart = () => useContext(CartContext);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("lc_cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("lc_cart", JSON.stringify(items));
  }, [items]);

  const addItem = (book) => {
    setItems((prev) => {
      const found = prev.find((i) => i.book_id === book.id);
      if (found) {
        return prev.map((i) =>
          i.book_id === book.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      }
      return [
        ...prev,
        {
          book_id: book.id,
          title: book.title,
          author: book.author,
          price: book.price,
          image_url: book.image_url,
          shipping_fee: book.shipping_fee ?? 0,
          quantity: 1,
        },
      ];
    });
  };

  const setQuantity = (bookId, qty) => {
    setItems((prev) =>
      prev
        .map((i) => (i.book_id === bookId ? { ...i, quantity: Math.max(0, qty) } : i))
        .filter((i) => i.quantity > 0)
    );
  };

  const removeItem = (bookId) =>
    setItems((prev) => prev.filter((i) => i.book_id !== bookId));

  const clearCart = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const shipping = items.length ? Math.max(...items.map((i) => i.shipping_fee || 0)) : 0;

  return (
    <CartContext.Provider
      value={{ items, addItem, setQuantity, removeItem, clearCart, count, total, shipping }}
    >
      {children}
    </CartContext.Provider>
  );
};
